module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QIUCQo78ELLDgAAASdJREFUSMftlbFKw2AUhb8bK9imZHBouqRgFxGkID6Bm0/gG+juXmqDD+DiIA59DgffoK6O3a2LS1toIT0OJvALgaYSxSFnPP/9/3PP4V5+qFDhv8OKFM1uwjukp68bdt6Mp9fZ2XwQXmIa+PF7VOStWrGurGNYACDoZPxi2L6Q9Fiw72KCAluYIokgVY8EZiDQ1baRepsKlv1WF5EYBAYBIln2W10AiaNtBTc6XHv0ME4FzdTh4dqjB0yA/dIF8ThA7ALHWcaCdnq6V3qkdWoPwMih7hsfwehX1wJgPgxfEDt+PD1xuBnCB/DjqZXi0BnXBFh94xI7A55LjdRBA6PuEv7t2xhjUu7QuIKgHOfh3woaYQ5bOSy0QGOU6/AVbFV9vBUq/BifZahRC3h9YEMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/10.png
// module id = 4jmY
// module chunks = 0